/**
 * Click-to-sort state shared by the analytics tables (retention audit,
 * published videos). Pure — the header component lives in SortableHead.
 */

export type SortDir = 'asc' | 'desc'

export interface SortState<C extends string> {
  col: C
  dir: SortDir
}

/** Three-state cycle per column: none → asc → desc → none. */
export function nextSort<C extends string>(prev: SortState<C> | null, col: C): SortState<C> | null {
  if (!prev || prev.col !== col) return { col, dir: 'asc' }
  if (prev.dir === 'asc') return { col, dir: 'desc' }
  return null
}
